module.exports = __webpack_public_path__ + "static/media/aristamd_logo.a7d0d484.svg";